import { Typography } from "@mui/material"
import type { FC } from "react"

import type { Location } from "@/graphql/codegen/graphql"
import { AddressFormat } from "@/types/common"
import { formatLocationAddress } from "@/utils/utils"

interface CustomerOrderAddressCellProps {
  location?: Location | null
  testId?: string
}

export const CustomerOrderAddressCell: FC<CustomerOrderAddressCellProps> = ({ location, testId }) => {
  if (!location) return null

  return (
    <Typography component='span' data-testid={testId} className='text-sm text-gray-700'>
      {formatLocationAddress(location, AddressFormat.AddressOnly)}
    </Typography>
  )
}
